import React, { Component } from "react";
import {
  InputGroup,
  Row,
  Col,
  Button,
  Table,
  Input
} from "reactstrap";
import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
import * as orderConstant from './constants'
import * as salaryAction from './actions'
import DisplayRecordText from "../../controls/_DisplayRecordText"
import CheckboxTreeList from "../../controls/_CheckboxTreeList";
import { currentDate,customSelectStylesMulti } from '../../../lib/common'
import AppConfig from "../../../config/app";
import Select from 'react-select';
const isNumber = require('is-number');
class SalaryReportDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      item: {},
      list: [],
      total_record: 0,
      tongSl: 0,
      tongDoanhSo: 0,
      tongBonus: 0,
      page: 1,
      per_page: 20,
      multipleValueNVKD: [],
      selectedOption: null,
      trangThai: [],
      isTDV: false
    };
    this.handleChangeControls = this.handleChangeControls.bind(this);
  }
  handleChangeControls(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
      case "isTDV":
        this.setState({ isTDV: e.target.checked });
        break;
    }
  }
  onHandleRemoveNvkd = () => {
    this.setState({ multipleValueNVKD: [] })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueNVKD: multipleValue })
  }
  fetchNvkd = (quanlys) => {
    const { salaryReportDetailNvkdRequest } = this.props
    var requestData = {
      userIds: quanlys
    };
    return salaryReportDetailNvkdRequest(requestData);
  }
  fetchList(page) {
    const { salaryReportDetailListRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      listNvkd: this.state.multipleValueNVKD,
      trangThai: this.state.trangThai,
      page: page || this.state.page,
      isTDV: this.state.isTDV,
      per_page: this.state.per_page
    }
    return salaryReportDetailListRequest(requestData)
  }
  fetchListInitData() {
    const { salaryReportDetailListRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      listNvkd: this.state.multipleValueNVKD,
      trangThai: this.state.trangThai,
      isTDV: this.state.isTDV,
      page: this.state.page,
      per_page: this.state.per_page
    }
    return salaryReportDetailListRequest(requestData)
  }
  exportXls = () => {
    const { reportExportXlsRequest } = this.props
    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      listNvkd: this.state.multipleValueNVKD.join(","),
      trangThai: this.state.trangThai,
      isTDV: this.state.isTDV
    };
    return reportExportXlsRequest(requestData, (listEXP) => {
      var dataFile = new Blob([listEXP], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportSalary';
      var fileName = "doanhsochitiet_luong.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportSalary";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.salaryReportDetail.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  handleChangeTrangThai = selectedOption => {
    var multipleValue = [];
    selectedOption.forEach(function (item) {
      multipleValue.push(parseInt(item.value));
    });
    this.setState({ selectedOption, trangThai: multipleValue });
  };
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  viewDS = () => {
    this.props.history.push('/salary-report');
  };
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1), // remove the "?" at the start
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  checkNVId = (callback) => {
    let nv = this.getParam("nv");
    let vt = this.getParam("vt");
    var multipleValueNVKD = [];
    if (isNumber(nv)) {
      multipleValueNVKD.push(parseInt(nv));
      this.search();
    };
    let isTDV = false
    if (vt == true || vt=="true") {
      isTDV = true
    };
    this.setState({ multipleValueNVKD, isTDV}, callback)
  }
  initData = () => {
    this.fetchNvkd();
  }
  componentDidMount() {
    this.checkNVId(this.initData)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.salaryReportDetail.type == orderConstant.SALARY_REPORT_DETAIL_LIST_SUCCESS) {
      let { list, item } = nextProps.salaryReportDetail;
      this.setState(
        {
          page: item.page,
          per_page: item.per_page,
          total_record: item.total_record,
          tongSl: item.tongSl || 0,
          tongDoanhSo: item.tongDoanhSo || 0,
          tongBonus: item.tongBonus || 0,
          list: list
        }
      )
    }
  }
  render() {
    const {
      list,
      selectedOption
    } = this.state
    const baoCaoTrangThai = [{ value: AppConfig.ORDER_STATUS.HoanThanhNhap, label: AppConfig.ORDER_STATUS.HoanThanhNhapText },
      { value: AppConfig.ORDER_STATUS.DangXuLy, label: AppConfig.ORDER_STATUS.DangXuLyText },
      { value: AppConfig.ORDER_STATUS.HoanThanh, label: AppConfig.ORDER_STATUS.HoanThanhText }
      ];
    const {
      handleSubmit,
      salaryReportDetail: {
        listRequesting
      },
    } = this.props
    const buildSelectOptionNVKD = (listNVKD) => {
      if (listNVKD && listNVKD.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        const NvkdChecked = listNVKD.map((item) => { return { value: item.Id } })
        this.onHandleChoiceNvkd(NvkdChecked)
      };
      return listNVKD || [];
    }
    return (
      <div className="animated fadeIn report">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="2" xs="6" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      name="tuNgay"
                      placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleChangeControls.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleChangeControls.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2">
                  <Select
                    styles={customSelectStylesMulti}
                    value={selectedOption}
                    onChange={this.handleChangeTrangThai}
                    options={baoCaoTrangThai}
                    placeholder="Trạng thái"
                    className="form-control p-0"
                    isMulti
                    closeMenuOnSelect={false}
                  />
                </Col>
                <Col sm="5" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={this.props.salaryReportDetail.listNVKD}
                      isMultiChoice={true}
                      checked={this.state.multipleValueNVKD}
                      onHandleRemove={(item) => this.onHandleRemoveNvkd(item)}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                    <label className="checkcustom checkcustom-embed-r45">
                      <Input type="checkbox" id="tdv" 
                      onChange={this.handleChangeControls.bind(this, "isTDV")}
                      checked={this.state.isTDV}>
                      </Input>
                      <span className="checkmark"></span>Vai trò TDV
                    </label>
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="w-100 mb-2 mt-2 mb-2">
            <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
            <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            <Button size="md" color="success" className="mr-1" onClick={() => this.viewDS()}><i className="fa fa-list"></i> Danh sách</Button>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Ngày tháng</th>
                    <th scope="col" className="text-left">Nhân viên</th>
                    <th scope="col" className="text-left">Nhóm</th>
                    <th scope="col" className="text-left">Tên hàng</th>
                    <th scope="col" className="text-right">Số lượng</th>
                    <th scope="col" className="text-right">Đơn giá</th>
                    <th scope="col" className="text-right">Doanh số</th>
                    <th scope="col" className="text-right">% Bonus</th>
                    <th scope="col" className="text-right">Bonus</th>
                   
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="6" className="text-right">
                      Tổng:
                     <span className="text-success">
                        {this.state.tongSl &&
                          this.state.tongSl}</span>
                    </th>
                    <th></th>
                    <th scope="col"className="text-right">
                     <span className="text-success">
                        {this.state.tongDoanhSo &&
                          this.state.tongDoanhSo.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th></th>
                    <th scope="col"  className="text-right">
                     <span className="text-success">
                        {this.state.tongBonus &&
                          this.state.tongBonus.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                  </tr>
                </tfoot>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.NgayThang}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        <td className="text-left">{res.Nhom}</td>
                        <td className="text-left">{res.TenHang}</td>
                        <td className="text-right">{res.SoLuong}</td>
                        <td className="text-right">{parseFloat(res.GiaBan || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.ThanhTien || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.BonusPercent || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.Bonus || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                      </tr>
                    ))
                  )}
                </tbody>

              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  salaryReportDetail: state.salaryReportDetail,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  salaryReportDetailListRequest: salaryAction.salaryReportDetailListRequest,
  salaryReportDetailNvkdRequest: salaryAction.salaryReportDetailNvkdRequest,
  reportExportXlsRequest: salaryAction.reportExportXlsRequest
})(SalaryReportDetail)

const formed = reduxForm({
  form: 'salaryReportDetail',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/Reports/SalaryReportDetail/SalaryReportDetail.js